import { TireDetail } from "@/@types/Tire";
import { TireDetailResponse } from "../tires/models/TireDetailsResponse";

export function mapTireDetails(response: TireDetailResponse): TireDetail {
    return {
        title: response.title,
        subtitle: response.subtitle,
        description: response.description,
        industrySlug: response.industry_slug,
        image: response.image,
        specs: response.specs,
        slug: response.slug,
        images: response.images.map(image => ({
            name: image.name,
            order: image.order,
        })),
        features: response.features.map(feature => ({
            feature: feature.feature,
        })),
        files: response.files.map(file => ({
            file: file.file,
            fileName: file.file_name,
        })),
    }
}